module.exports = __webpack_public_path__ + "static/media/bellabyte-folder-informativo-768x591.dc104131.jpg";